'use client';

import type { FC } from 'react';
import { DEFAULT_LOCALE } from '@/core/constants';
import parseLocale from '@/core/i18n/parse-locale';
import Img from '@/ui/components/Img/Img';
import Link from '@/ui/components/Link/Link';
import { useGA4 } from '@/ui/context/ga4';
import useLocaleParams from '@/ui/hooks/use-locale-params';

interface AppStoreButtonProps {
  appId: string;
  disabled?: boolean;
}

const APP_STORE_CLICK_TEXT = 'Download Mind Oasis in the App Store';

const AppStoreButton: FC<AppStoreButtonProps> = ({ appId, disabled }) => {
  const { country } = useLocaleParams();
  const { trackInteraction } = useGA4();
  const storeCountry = country || parseLocale(DEFAULT_LOCALE).country;
  const href = `https://apps.apple.com/${storeCountry}/app/${appId}`;

  const content = (
    <>
      <span className="sr-only">{APP_STORE_CLICK_TEXT}</span>
      <Img
        src="/images/app-store-button.png"
        alt=""
        width={155}
        height={45}
      />
    </>
  );

  if (disabled) {
    return <span aria-disabled="true">{content}</span>;
  }

  return (
    <Link
      href={href}
      isExternal
      ariaLabel={APP_STORE_CLICK_TEXT}
      onClick={() =>
        trackInteraction({
          interaction_type: 'hyperlink',
          click_target: href,
          click_text: APP_STORE_CLICK_TEXT,
          content_name: 'app_download',
        })
      }
    >
      {content}
    </Link>
  );
};

export default AppStoreButton;
